// extracted by mini-css-extract-plugin
export default {"speechBubble":"SceneOverlay_speechBubble__iptHw","right":"SceneOverlay_right__v0U-v","iconButton":"SceneOverlay_iconButton__6VenV"};